import { render, staticRenderFns } from "./editBenefit.vue?vue&type=template&id=29e80909&scoped=true"
import script from "./editBenefit.vue?vue&type=script&lang=js"
export * from "./editBenefit.vue?vue&type=script&lang=js"
import style0 from "./editBenefit.vue?vue&type=style&index=0&id=29e80909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e80909",
  null
  
)

export default component.exports